import Autocomplete from "@mui/material/Autocomplete";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";

import ApiAutocomplete from "@/common/ApiAutocomplete";
import { queryToFilterValue, statusQueryToFilterValue } from "@/utils";
import { bidStatuses } from "@/sheet/constants";

export default function BidFilters(props) {
    const {
        filters,
        setFilters,
        handleInputChange,
        handleAutocompleteChange,
        handleAutocompleteClear,
    } = props;

    const handleMultiAutoCompleteChange = (filterName) => (event, newValue) => {
        if (newValue && newValue.length > 0) {
            setFilters({
                ...filters,
                [filterName]: "in:" + newValue.join(","),
            });
        }
    };

    return (
        <Grid container sx={{ paddingTop: 2 }} spacing={3}>
            <Grid item xs={12} md={4}>
                <TextField
                    value={queryToFilterValue(filters.name) || ""}
                    sx={{ width: "100%" }}
                    onChange={handleInputChange("name")}
                    label="Name"
                    variant="outlined"
                />
            </Grid>
            <Grid item xs={12} md={4}>
                <ApiAutocomplete
                    silentErrors
                    value={queryToFilterValue(filters.project_id)}
                    apiRoute={"projects"}
                    fields={["name"]}
                    onChange={handleAutocompleteChange("project_id")}
                    onInputChange={handleAutocompleteClear("project_id")}
                    label={"Project"}
                />
            </Grid>
            <Grid item xs={12} md={4}>
                <Autocomplete
                    value={statusQueryToFilterValue(filters.status) || []}
                    multiple
                    disablePortal
                    options={bidStatuses}
                    isOptionEqualToValue={(option, value) =>
                        value.includes(option)
                    }
                    onChange={handleMultiAutoCompleteChange("status")}
                    onInputChange={handleAutocompleteClear("status")}
                    renderInput={(params) => (
                        <TextField {...params} label="Status" />
                    )}
                />
            </Grid>
        </Grid>
    );
}
